angular.module('ikeweb.routes').constant('routes', {
    LOG_IN: {
        url: '/login',
        views: {
            main: {
                templateUrl: require('../templates/login.html'),
                controller: 'LoginController',
                controllerAs: 'ctrl'
            }
        }
    },
    FORGOT_PASSWORD: {
        url: '/forgotPassword',
        views: {
            main: {
                templateUrl: require('../templates/forgotPassword.html'),
                controller: 'ForgotPasswordController'
            }
        }
    },
    GALLERY: {
        url: '/gallery',
        views: {
            main: {
                templateUrl: require('../templates/gallery.html'),
                controller: 'GalleryController'
            }
        }
    },
    PHOTOMEASURE: {
        url: '/photoMeasure/:spikeid',
        views: {
            main: {
                templateUrl: require('../templates/photoMeasure.html'),
                controller: 'PhotoMeasureViewController',
                controllerAs: 'pmViewCtrl'
            }
        }
    },
    ALIGN: {
        url: '/photoMeasure/:spikeid/align',
        views: {
            main: {
                templateUrl: require('../templates/photoMeasure.html'),
                controller: 'PhotoMeasureViewController',
                controllerAs: 'pmViewCtrl'
            }
        }
    },
    MEASURE: {
        url: '/photoMeasure/:spikeid/measure',
        views: {
            main: {
                templateUrl: require('../templates/photoMeasure.html'),
                controller: 'PhotoMeasureViewController',
                controllerAs: 'pmViewCtrl'
            }
        }
    },
    REPORT: {
        url: '/photoMeasure/:spikeid/report',
        views: {
            main: {
                templateUrl: require('../templates/report.html'),
                controller: 'ReportController',
                controllerAs: 'ctrl'
            }
        }
    },
    SHARED_REPORT: {
        url: '/measureView/:sharedCaptureId',
        views: {
            main: {
                templateUrl: require('../templates/measureView.html'),
                controller: 'MeasureViewController',
                controllerAs: 'ctrl'
            }
        }
    },
    MAP: {
        url: '/map',
        views: {
            main: {
                templateUrl: require('../templates/map.html'),
                controller: 'MapViewController',
                controllerAs: 'mapViewCtrl'
            }
        }
    },
    BILLING: {
        url: '/billing?{upgrade:bool}',
        views: {
            main: {
                templateUrl: require('../templates/billing.html'),
                controller: 'BillingController',
                controllerAs: 'ctrl'
            }
        },
        reloadOnSearch: false
    },
    CHOOSE_PASSWORD: {
        url: '/choose_password?token&username&error',
        views: {
            main: {
                templateUrl: require('../templates/choose_password.html'),
                controller: 'ChoosePasswordController'
            }
        }
    },
    INVALID_LINK: {
        url: '/invalid_link',
        views: {
            main: {
                templateUrl: require('../templates/invalid_link.html')
            }
        }
    },
    PASSWORD_RESET_SUCCESS: {
        url: '/password_reset_success',
        views: {
            main: {
                templateUrl: require('../templates/password_reset_success.html')
            }
        }
    },
    ERROR: {
        url: '/error/:errorKey',
        views: {
            main: {
                templateUrl: require('../templates/error.html'),
                controller: 'ErrorController'
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/client/routes/routes.js
// module id = 424
// module chunks = 0